import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

export function useFavorites() {
  const [favorites, setFavorites] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [userId, setUserId] = useState<string | null>(null);

  useEffect(() => {
    supabase.auth.getUser().then(({ data: { user } }) => {
      if (user) {
        setUserId(user.id);
        fetchFavorites(user.id);
      } else {
        setLoading(false);
      }
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session?.user) {
        setUserId(session.user.id);
        fetchFavorites(session.user.id);
      } else {
        setUserId(null);
        setFavorites([]);
        setLoading(false);
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  const fetchFavorites = async (uid: string) => {
    try {
      const { data, error } = await supabase
        .from('favorites')
        .select('*')
        .eq('user_id', uid);
      
      if (error) throw error;
      setFavorites(data || []);
    } catch (error) {
      console.error('Erreur chargement favoris:', error);
    } finally {
      setLoading(false);
    }
  };

  const toggleFavorite = async (item: any, type: 'hotel' | 'activity') => {
    if (!userId) {
      alert("Connectez-vous pour ajouter des favoris !");
      return;
    }

    const rawId = item.hotelId || item.id;
    if (!rawId) return;
    const itemId = String(rawId);

    const existing = favorites.find(f => String(f.item_id) === itemId);

    if (existing) {
      // Suppression
      setFavorites(prev => prev.filter(f => f.id !== existing.id));
      const { error } = await supabase.from('favorites').delete().eq('id', existing.id);
      if (error) setFavorites(prev => [...prev, existing]); 
    } else {
      // Ajout
      const saveData = {
        name: item.name || "Sans nom",
        image: item.image || (item.images && item.images[0] ? item.images[0].url : null),
        location: item.address?.cityName || item._embedded?.venues?.[0]?.name || "Localisation inconnue",
        rating: item.rating || null,
        url: item.url || null
      };

      const tempId = Date.now(); 
      const tempFav = { id: tempId, user_id: userId, item_id: itemId, type, data: saveData };
      setFavorites(prev => [...prev, tempFav]);

      const { data, error } = await supabase
        .from('favorites')
        .insert([{ user_id: userId, item_id: itemId, type: type, data: saveData }])
        .select();

      if (error) {
        console.error("Erreur ajout favori:", error);
        setFavorites(prev => prev.filter(f => f.id !== tempId));
      } else if (data) {
        setFavorites(prev => prev.map(f => f.id === tempId ? data[0] : f));
      }
    }
  };

  const isFavorite = (itemId: any) => {
    if (!itemId) return false;
    return favorites.some(f => String(f.item_id) === String(itemId));
  };

  return { favorites, loading, toggleFavorite, isFavorite, userId };
}
